/* eslint-disable */

$(function() {
  $('#hoge').popover({
    trigger: 'hover' // click,hover,focus,manualを選択出来る

  });
});


// WEBPACK FOOTER //
// ./es6/admin-pages-js/etc/login.js